import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid/main';
import { menuIdRouteMappings } from '../../../../constants';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';

@Component({
  selector: 'lfwms-search-criteria-cell-renderer',
  templateUrl: './search-criteria-cell-renderer.component.html',
  styleUrls: ['./search-criteria-cell-renderer.component.css']
})
export class SearchCriteriaCellRendererComponent implements ICellRendererAngularComp {

  public isLoading: boolean = true;
  public params: any;

  constructor(private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {}

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isLoading = false;
  }

  public refresh(params: any): boolean {
    return true;
  }

  public edit() {
    const targetCell: any = {
      colKey: this.params.column.colId,
      rowIndex: this.params.rowIndex
    };
    if (this.params.context.componentParent.tableMode !== 'E') {
      this.params.context.componentParent.targetCell = targetCell;
      this.params.context.componentParent.searchService.displayMode = 'E';
    } else {
      this.params.api.stopEditing();
      this.params.api.startEditingCell(targetCell);
    }
  }

  public navigateToSearchScreen() {
   // this.coreServiceRegistry.navigationService.navigateByMenuId('home');
    const itemType = this.params.node.data.itemModule.cVal;
    const url: string = menuIdRouteMappings[itemType] + '/search';
    this.coreServiceRegistry.navigationService.resetBreadcrumb('home')
      .addBreadCrumbItem(this.coreServiceRegistry.resourceService
        .get('mn_' + itemType), itemType.toLowerCase());
    this.coreServiceRegistry.navigationService
      .navigateWithRouteParams(url, [this.params.node.data.searchId.cVal]);
    this.sharedServiceRegistry.sceModalService.modalReference.hide();
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/search-criteria-popup/search-criteria-cell-renderer/search-criteria-cell-renderer.component.ts